import React from 'react';
import {
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip
} from 'recharts';

const dadosPadrao = [
  { dimensao: 'Física', notaAtual: 0, fullMark: 100 },
];

const LonjovialRadarChart = ({ dadosExternos }) => {
  const data = dadosExternos || dadosPadrao;

  return (
    <div className="w-full h-96 bg-white p-4 rounded-xl shadow-lg flex flex-col items-center border border-gray-100">
      <h3 className="text-xl font-bold text-gray-800 mb-2">Seu Radar da Lonjovialidade</h3>
      <p className="text-sm text-gray-500 mb-4">Retrato do seu equilíbrio atual</p>
      
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="75%" data={data}>
          <PolarGrid stroke="#e5e7eb" />
          <PolarAngleAxis dataKey="dimensao" tick={{ fill: '#4b5563', fontSize: 11, fontWeight: 'bold' }} />
          
          {/* Eixo invisível apenas para garantir a escala de 0 a 100 */}
          <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} axisLine={false} />
          
          {/* REMOVIDO: Radar do Ciclo Anterior (Dado fixo) */}
          
          {/* Radar do Ciclo Atual */}
          <Radar
            name="Ciclo Atual"
            dataKey="notaAtual"
            stroke="#2563eb"
            strokeWidth={3}
            fill="#3b82f6"
            fillOpacity={0.5}
          />
          
          <Legend wrapperStyle={{ paddingTop: '10px' }} />
          <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LonjovialRadarChart;